import classNames from "classnames";

import { TestProps } from "shared/types";

interface Props
  extends React.ButtonHTMLAttributes<HTMLButtonElement>, TestProps {
  children: React.ReactNode;
  onClick: () => void;
  className?: string;
}

const LinkButton = ({ children, onClick, className, ...otherProps }: Props) => (
  <button
    onClick={onClick}
    className={classNames(
      "underline-offset-2 text-ellipsis overflow-hidden whitespace-nowrap underline text-gray-700 hover:text-gray-500",
      className
    )}
    {...otherProps}
  >
    {children}
  </button>
);

export default LinkButton;
